// Colors for the builder's own chrome (not the doclet content, which uses
// src/doclets/tokens.ts), from the World 50 Design Guidelines v2.0. Comments
// name the guide's tokens. Scoped to the builder: MI6's shared theme is
// unchanged.
export const builderColors = {
  // --surface-sunken (ink-200)
  canvas: '#EDEDED',
  // --surface-page
  sidebar: '#FFFFFF',
  // --border-default (ink-300)
  border: '#D3D2D1',
  // --text-primary
  text: '#141413',
  // --text-secondary (ink-700)
  mutedText: '#686764',
  // --surface-sunken (ink-200)
  iconFill: '#EDEDED',
  // --accent-hover: Sky Blue itself is too light for small text
  tag: '#177BBD',
  // --accent (Sky Blue): selection outline
  selectedBorder: '#109EDA',
  // --w50-blue-50
  selectedFill: '#F0F7FF',
  // --accent-soft (Ice Blue)
  hoverBorder: '#DAE8F8',
  // --danger
  danger: '#C32F0B',
  // --accent-soft (Ice Blue)
  activeFill: '#DAE8F8'
}

// --radius-*
export const builderRadii = {
  xs: 2,
  md: 8
}

// --shadow-sm / --shadow-md, as React Native shadow props
export const builderShadows = {
  sm: {
    shadowColor: '#141413',
    shadowOpacity: 0.08,
    shadowRadius: 3,
    shadowOffset: { width: 0, height: 1 }
  },
  md: {
    shadowColor: '#141413',
    shadowOpacity: 0.08,
    shadowRadius: 12,
    shadowOffset: { width: 0, height: 4 }
  }
}
